import { render, staticRenderFns } from "./UploadCoverScribe.vue?vue&type=template&id=802985a0&"
import script from "./UploadCoverScribe.vue?vue&type=script&lang=js&"
export * from "./UploadCoverScribe.vue?vue&type=script&lang=js&"
import style0 from "./UploadCoverScribe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports